import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "dot"]

  connect() {
    this.currentIndex = Math.floor(Math.random() * this.itemTargets.length);
    this.showTestimonial(this.currentIndex);
  }

  goTo(event) {
    event.stopPropagation();
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this.currentIndex = index;
    this.showTestimonial(this.currentIndex);
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.itemTargets.length;
    this.showTestimonial(this.currentIndex);
  }

  showTestimonial(index) {
    this.itemTargets.forEach((item, i) => {
      item.style.display = i === index ? "block" : "none";
    });

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });
  }
}
